/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IngestionStatusControllerGetJobStatsQueryResponse, IngestionStatusControllerGetJobStatsQueryParams, IngestionStatusControllerGetJobStats403 } from "../../models/documentIngestionStatusController/IngestionStatusControllerGetJobStats";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { ingestionStatusControllerGetJobStats } from "../../clients/document-ingestion-statusService/ingestionStatusControllerGetJobStats";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const ingestionStatusControllerGetJobStatsQueryKey = (params: IngestionStatusControllerGetJobStatsQueryParams = {}) => [{
  url: '/api/v1/documents/ingestion-status/jobs'
}, ...(params ? [params] : [])] as const;
export type IngestionStatusControllerGetJobStatsQueryKey = ReturnType<typeof ingestionStatusControllerGetJobStatsQueryKey>;
export function ingestionStatusControllerGetJobStatsQueryOptions(params?: IngestionStatusControllerGetJobStatsQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = ingestionStatusControllerGetJobStatsQueryKey(params);
  return queryOptions<IngestionStatusControllerGetJobStatsQueryResponse, ResponseErrorConfig<IngestionStatusControllerGetJobStats403>, IngestionStatusControllerGetJobStatsQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return ingestionStatusControllerGetJobStats(params, config);
    }
  });
}

/**
 * @description Returns statistics about the job processing system, including job counts by status and type, failure rates, retry rates, and recent failures. Requires System Administrator role.
 * @summary Get job system statistics
 * {@link /api/v1/documents/ingestion-status/jobs}
 */
export function useIngestionStatusControllerGetJobStats<TData = IngestionStatusControllerGetJobStatsQueryResponse, TQueryData = IngestionStatusControllerGetJobStatsQueryResponse, TQueryKey extends QueryKey = IngestionStatusControllerGetJobStatsQueryKey>(params?: IngestionStatusControllerGetJobStatsQueryParams, options: {
  query?: Partial<QueryObserverOptions<IngestionStatusControllerGetJobStatsQueryResponse, ResponseErrorConfig<IngestionStatusControllerGetJobStats403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? ingestionStatusControllerGetJobStatsQueryKey(params);
  const query = useQuery({
    ...ingestionStatusControllerGetJobStatsQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<IngestionStatusControllerGetJobStats403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}